import { render, staticRenderFns } from "./MarkupContent.vue?vue&type=template&id=a0313cec&"
import script from "./MarkupContent.vue?vue&type=script&lang=js&"
export * from "./MarkupContent.vue?vue&type=script&lang=js&"
import style0 from "./MarkupContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports